<script>
  import { _ } from "svelte-i18n";
  let showDetails = false;
  function toggle() {
    showDetails = !showDetails;
  }

  import Radio from "./Radio.svelte";
  export let quality;
  export let length;
</script>

<div class="form-section form-section--paddingless">
  <h3>
    <button
      on:click={toggle}
      type="button"
      class="button-text button-text--chevron-down {showDetails
        ? 'is-toggled'
        : ''}">{$_("dayParameters.form.sleep.title")}</button
    >
  </h3>
  <div class={showDetails ? "" : "radio-group--default-hide"}>
    <h4 class="">{$_("dayParameters.form.sleep.quality")}</h4>
    <div>
      <div class="radio-group__labels false">
        <span class="radio-group__label radio-group__label--left"
          >{$_("dayParameters.form.sleep.low")}</span
        ><span class="radio-group__label"></span><span
          class="radio-group__label radio-group__label--right"
          >{$_("dayParameters.form.sleep.high")}</span
        >
      </div>
      <div class="radio-group radio-group--1-10">
        {#each { length: 10 } as _, index}
          <Radio bind:group={quality} value={index + 1} label="Søvnkvalitet"
          ></Radio>
        {/each}
      </div>
    </div>
    <label for=""
      ><span class="input__label">{$_("dayParameters.form.sleep.length")}</span
      ><span class="input__item"
        ><input
          type="text"
          class="input__number"
          data-label=""
          data-id=""
          name="sleepNight"
          id=""
          autocomplete="off"
          bind:value={length}
        />

        <p class="input__error"></p>
      </span></label
    >
  </div>
</div>
